import { appIntervalId, commonFiltersValue, disableButton, isLoadingCommonFilters } from "@signals"
import { useToast } from "./index"


const __defaultSubmit = async data => console.log(data)

export default function useCommonFilter(isValid = true) {
	const { showToast } = useToast()

	disableButton.value = !isValid

	const handleSubmit = onSubmit => {
		isLoadingCommonFilters.value = true
		disableButton.value = true
		const fn = onSubmit || __defaultSubmit
		if (isValid) {
			try {
				fn(commonFiltersValue.value)
					.catch(() => {
						showToast.error()
					})
					.finally(() => {
						if (appIntervalId.value === null) {
							isLoadingCommonFilters.value = false
							disableButton.value = false
						}
					})
			} catch (err) {
				if (err.name === 'TypeError' && err.message.includes("Cannot read properties of undefined (reading 'catch')")) {
					console.warn("[FILTER WARNING] It is advisable that 'onSubmit' returns a function if possible.")
				} else {
					showToast.error()
				}
				isLoadingCommonFilters.value = false
				disableButton.value = false
			}
		}
		if (!isValid) {
			showToast.error('Please check required fields to get results')
			isLoadingCommonFilters.value = false
			disableButton.value = false
		}

	}

	return {
		handleSubmit,
		disableButton: disableButton.value
	}
}